import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, GroupMembership } from "@shared/models/group"
import { handleError } from "cc-frontend/error-handling"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembership
    group: Group
  }
}

export default class GroupMembersTableActionsIgnorePotentialCell extends Component<Signature> {
  @service("ember-store") declare store: EmberStore
  @service declare rpc: Rpc
  @service declare dialog: Dialog
  @tracked ignoringPotential = false

  rpcToIgnorePotential(groupId: string, membershipId: string) {
    this.rpc
      .group_ignore_other_membership({
        groupId,
        membershipId,
      })
      .then(() => {
        if (this.isDestroyed || this.isDestroying) return
        later(() => (this.ignoringPotential = false), 250)
      })
  }

  @action
  removeMember() {
    this.dialog
      .blank("dialogs/confirm-ignore-membership-potential", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.ignoringPotential = true
        this.rpcToIgnorePotential(this.args.group.id, this.args.row.id)
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::ActionsIgnorePotential": typeof GroupMembersTableActionsIgnorePotentialCell
  }
}
